import BounceLoader from "react-spinners/BounceLoader";
import React from "react";
import './Loader.scss';

export const LoaderFullScreen = () => {
    return (
        <div className={'Loader'}>
            <p className={'Loader-info'}>Chargement ...</p>
            <BounceLoader/>
        </div>
    )
};